import React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { useToaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

import {
  APP_DRAWER_COLLAPSED_WIDTH,
  APP_DRAWER_EXPANDED_WIDTH,
} from '../../components/layout/DrawerLayout/AppDrawerLayout/AppDrawerLayout';
import { appraisalPath } from '../../constants';
import { useToasterContext } from '../../contexts/ToasterContext';
import CustomToast from './CustomToast/CustomToast';
import { Container } from './CustomToaster.styles';

const NOTIFICATIONS_PANEL_WIDTH = '27rem';
const TOAST_LEFT_MARGIN = '1.5rem';
export const MAX_AMOUNT_OF_NOTIFICATIONS_IN_STACK = 3;

const CustomToaster = () => {
  const { toasts, handlers } = useToaster();
  const { pathname } = useLocation();
  const { startPause, endPause } = handlers;
  const { toasterDrawerIsOpen, toasterNotificationsIsOpen } = useToasterContext();
  const [activeToastId, setActiveToastId] = useState<string>(undefined);

  const isAppraisalPage = pathname === appraisalPath;

  const leftPos = useMemo(
    () =>
      isAppraisalPage
        ? '1.5rem'
        : `calc(${toasterDrawerIsOpen ? APP_DRAWER_EXPANDED_WIDTH : APP_DRAWER_COLLAPSED_WIDTH} + ${
            toasterNotificationsIsOpen ? NOTIFICATIONS_PANEL_WIDTH : '0rem'
          } + ${TOAST_LEFT_MARGIN})`,
    [toasterDrawerIsOpen, toasterNotificationsIsOpen, isAppraisalPage],
  );

  const totalScreenNotifications = useMemo(() => {
    return toasts.filter((tt) => tt.visible).length;
  }, [toasts]);

  useEffect(() => {
    for (let i = toasts.length - 1; i >= 0; i--) {
      if (toasts[i].visible) {
        setActiveToastId(toasts[i].id);
        break;
      }
    }
  }, [toasts]);

  const visibleToasts = useMemo(() => {
    // get MAX_AMOUNT_OF_NOTIFICATIONS_IN_STACK + 1 count to take also a disappearing notification
    const toastsRet = toasts.reverse().slice(-(MAX_AMOUNT_OF_NOTIFICATIONS_IN_STACK + 1));
    if (toastsRet.length > MAX_AMOUNT_OF_NOTIFICATIONS_IN_STACK && toastsRet?.[toastsRet.length - 1].visible) {
      // we remove last notification if there is no disappearing notification
      toastsRet.shift();
    }
    return toastsRet;
  }, [toasts]);

  return (
    <Container $left={leftPos} onMouseEnter={startPause} onMouseLeave={endPause}>
      {visibleToasts.map((toast, index) => (
        <CustomToast
          key={toast.id}
          toast={toast}
          index={index}
          active={toast.id === activeToastId}
          totalAmount={totalScreenNotifications > 1 && totalScreenNotifications}
        />
      ))}
    </Container>
  );
};

export default CustomToaster;
